import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "icn-file-label",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.scss"],
})
export class FileLabelComponent {
  @Input() label = "";
  @Output() remove = new EventEmitter();
  @Output() settingsClick = new EventEmitter();

  onRemove() {
    this.remove.emit(this);
  }
  onSettingsClick(event) {
    this.settingsClick.emit(event);
  }
}
